class Notifications {
  constructor(el) {
    this.el = el;
  }
  // function to create new elements with a class (cleans up code)
  createDiv(className = "") {
    const el = document.createElement("div");
    el.classList.add(className);
    return el;
  }
  // function to add text nodes to elements
  addText(el, text) {
    el.appendChild(document.createTextNode(text));
  }
  create(
    title = "Untitled notification",
    description = "",
    duration = 2,
    destroyOnClick = false,
    clickFunction = undefined
  ) {
    // functions
    function destroy(animate) {
      if (animate) {
        notiEl.classList.add("out");
        notiEl.addEventListener("animationend", () => {
          notiEl.remove();
        });
      } else {
        notiEl.remove();
      }
    }
    // create the elements and add their content
    const notiEl = this.createDiv("noti");
    const notiCardEl = this.createDiv("noticard");
    const glowEl = this.createDiv("notiglow");
    const borderEl = this.createDiv("notiborderglow");

    const titleEl = this.createDiv("notititle");
    this.addText(titleEl, title);

    const descriptionEl = this.createDiv("notidesc");
    this.addText(descriptionEl, description);

    // append the elements to each other
    notiEl.appendChild(notiCardEl);
    notiCardEl.appendChild(glowEl);
    notiCardEl.appendChild(borderEl);
    notiCardEl.appendChild(titleEl);
    notiCardEl.appendChild(descriptionEl);

    this.el.appendChild(notiEl);

    // transition the height of the container to the height of the visible card
    console.log("height", notiCardEl.scrollHeight);
    requestAnimationFrame(function () {
      notiEl.style.height =
        "calc(0.25rem + " + notiCardEl.getBoundingClientRect().height + "px)";
    });
    // hover animation
    notiEl.addEventListener("mousemove", (event) => {
      const rect = notiCardEl.getBoundingClientRect();
      const localX = (event.clientX - rect.left) / rect.width;
      const localY = (event.clientY - rect.top) / rect.height;

      console.log(localX, localY);
      glowEl.style.left = localX * 100 + "%";
      glowEl.style.top = localY * 100 + "%";

      borderEl.style.left = localX * 100 + "%";
      borderEl.style.top = localY * 100 + "%";
    });

    // onclick function if one is set
    if (clickFunction != undefined) {
      notiEl.addEventListener("click", clickFunction);
    }

    // destroy the notification on click if it is set to do so
    if (destroyOnClick) {
      notiEl.addEventListener("click", () => destroy(true));
    }

    // remove the notification after the set time if there is one
    if (duration != 0) {
      setTimeout(() => {
        notiEl.classList.add("out");
        notiEl.addEventListener("animationend", () => {
          notiEl.remove();
        });
      }, duration * 1000);
    }
    return notiEl;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const MAX_PRIMARY_SELECTIONS = 9;

  const notificationsContainer = document.querySelector(".notifications");
  const notis = notificationsContainer
    ? new Notifications(notificationsContainer)
    : null;

  // State management
  let primarySelections = new Map(); // Map of variant ID to { quantity, title, handle, imageUrl }
  let bonusSelections = new Map();   // Map of variant ID to { quantity, title, handle, imageUrl }
  let bonusUnlocked = false;
  let currentTier = 0; // 0 = locked, 1 = 3+1, 2 = 6+2, 3 = 9+3

  // Helper: generate a unique bundle instance ID per "Add to cart"
  function createBundleInstanceId() {
    return `bundle-${Date.now().toString(36)}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
  }

  // Get max bonus selections based on tier
  function getMaxBonusForTier(tier) {
    // tier 1 = 1 bonus, tier 2 = 2 bonus, tier 3 = 3 bonus
    return tier;
  }

  // Get tier from primary selections
  function getTierFromPrimary(primaryCount) {
    if (primaryCount >= 9) return 3;
    if (primaryCount >= 6) return 2;
    if (primaryCount >= 3) return 1;
    return 0;
  }

  // DOM Elements
  const primaryCollection = document.querySelector('.primary-collection');
  const secondaryCollection = document.querySelector('.secondary-collection');
  const bonusLockedSection = document.getElementById('bonusLocked');
  const bonusUnlockedSection = document.getElementById('bonusUnlocked');
  const addToCartButtons = [document.getElementById('addToCartButton'), document.getElementById('addToCartButtonBTM')];
  const selectedItemsContainer = document.getElementById('selectedItemsContainer');
  const selectedBonusItemsContainer = document.getElementById('selectedBonusItemsContainer');
  
  // Initialize event listeners
  function init() {
    // Primary collection event listeners
    if (primaryCollection) {
      primaryCollection.querySelectorAll('.product-card').forEach(card => {
        const decreaseBtn = card.querySelector('.decrease');
        const increaseBtn = card.querySelector('.increase');

        decreaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, -1, 'primary'));
        increaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, 1, 'primary'));
      });
    }
    
    // Secondary collection event listeners (initially disabled)
    if (secondaryCollection) {
      secondaryCollection.querySelectorAll('.product-card').forEach(card => {
        const decreaseBtn = card.querySelector('.decrease');
        const increaseBtn = card.querySelector('.increase');
        const variantSelect = card.querySelector('.variant-select');

        decreaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, -1, 'secondary'));
        increaseBtn.addEventListener('click', (e) => handleQuantityChange(e, card, 1, 'secondary'));

        // Handle variant selection
        if (variantSelect) {
          variantSelect.addEventListener('change', (e) => {
            const oldVariantId = card.dataset.variantId;
            const newVariantId = e.target.value;
            card.dataset.variantId = newVariantId;

            // Update selection if product already selected
            const currentQty = parseInt(card.querySelector('.quantity-count').textContent) || 0;
            if (currentQty > 0) {
              // Remove old variant
              bonusSelections.delete(oldVariantId);

              // Add new variant
              const productTitle = card.querySelector('.product-title').textContent;
              const variantTitle = e.target.options[e.target.selectedIndex].text;
              let displayTitle = productTitle;
              if (variantTitle !== 'Default Title' && variantTitle !== 'Select Size/Option') {
                displayTitle = `${productTitle} - ${variantTitle}`;
              }
              bonusSelections.set(newVariantId, {
                quantity: currentQty,
                title: displayTitle,
                handle: card.dataset.productHandle,
                imageUrl: card.dataset.imageUrl
              });
              updateBonusDisplay();
            }
          });
        }
      });
    }
    
    // Add to cart button event listeners
    addToCartButtons.forEach(button => {
      if (button) {
        button.addEventListener('click', handleAddToCart);
      }
    });
  }
  
  // Handle quantity changes
  function handleQuantityChange(event, card, change, collection) {
    event.preventDefault();

    const quantitySpan = card.querySelector('.quantity-count');
    const currentQty = parseInt(quantitySpan.textContent) || 0;
    const newQty = Math.max(0, currentQty + change);

    // Get variant ID from selector if exists, otherwise from data attribute
    let variantId = card.dataset.variantId;
    const variantSelect = card.querySelector('.variant-select');
    if (variantSelect) {
      variantId = variantSelect.value;
      card.dataset.variantId = variantId;
    }

    const productTitle = card.querySelector('.product-title').textContent;
    
    // Check if we can add more
    if (collection === 'primary') {
      const currentTotal = getTotalSelections(primarySelections);
      if (change > 0 && currentTotal >= MAX_PRIMARY_SELECTIONS) {
        if (notis) notis.create('Limit Reached', 'Maximum 9 products allowed.', 3, true);
        return;
      }
    } else if (collection === 'secondary') {
      if (!bonusUnlocked) {
        if (notis) notis.create('Locked', 'Select at least 3 products to unlock bonus items.', 3, true);
        return;
      }
      const currentTotal = getTotalSelections(bonusSelections);
      const maxBonus = getMaxBonusForTier(currentTier);
      if (change > 0 && currentTotal >= maxBonus) {
        if (notis) notis.create('Limit Reached', `Maximum ${maxBonus} bonus items for ${currentTier * 3} products.`, 3, true);
        return;
      }
    }
    
    // Update quantity
    quantitySpan.textContent = newQty;

    // Update selections
    if (collection === 'primary') {
      if (newQty === 0) {
        primarySelections.delete(variantId);
      } else {
        primarySelections.set(variantId, {
          quantity: newQty,
          title: productTitle,
          handle: card.dataset.productHandle,
          imageUrl: card.dataset.imageUrl
        });
      }
      updatePrimaryDisplay();
      checkUnlockBonus();
    } else {
      if (newQty === 0) {
        bonusSelections.delete(variantId);
      } else {
        let displayTitle = productTitle;
        if (variantSelect) {
          const variantTitle = variantSelect.options[variantSelect.selectedIndex].text;
          if (variantTitle !== 'Default Title' && variantTitle !== 'Select Size/Option') {
            displayTitle = `${productTitle} - ${variantTitle}`;
          }
        }
        bonusSelections.set(variantId, {
          quantity: newQty,
          title: displayTitle,
          handle: card.dataset.productHandle,
          imageUrl: card.dataset.imageUrl
        });
      }
      updateBonusDisplay();
    }
    
    updateButtons();
  }
  
  // Get total selections count
  function getTotalSelections(selectionsMap) {
    let total = 0;
    selectionsMap.forEach(item => {
      total += item.quantity;
    });
    return total;
  }
  
  // Update primary selection display
  function updatePrimaryDisplay() {
    const items = [];
    primarySelections.forEach(item => {
      for (let i = 0; i < item.quantity; i++) {
        items.push({ title: item.title, imageUrl: item.imageUrl });
      }
    });

    const emptySlots = MAX_PRIMARY_SELECTIONS - items.length;
    let html = '';

    items.forEach(item => {
      html += `<li class="filled-item"><img src="${item.imageUrl}" alt="${item.title}"><span>${item.title}</span></li>`;
    });

    for (let i = 0; i < emptySlots; i++) {
      html += '<li class="empty-item"></li>';
    }

    selectedItemsContainer.innerHTML = html;
  }
  
  // Update bonus selection display
  function updateBonusDisplay() {
    const items = [];
    bonusSelections.forEach(item => {
      for (let i = 0; i < item.quantity; i++) {
        items.push({ title: item.title, imageUrl: item.imageUrl });
      }
    });

    const maxBonus = getMaxBonusForTier(currentTier);
    const emptySlots = maxBonus - items.length;
    let html = '';

    items.forEach(item => {
      html += `<li class="filled-item filled"><img src="${item.imageUrl}" alt="${item.title}"><span>${item.title}</span></li>`;
    });

    for (let i = 0; i < emptySlots; i++) {
      html += '<li class="empty-bonus-item"></li>';
    }

    selectedBonusItemsContainer.innerHTML = html;
  }
  
  // Check if bonus collection should be unlocked
  function checkUnlockBonus() {
    const primaryTotal = getTotalSelections(primarySelections);
    const newTier = getTierFromPrimary(primaryTotal);

    if (newTier !== currentTier) {
      const oldTier = currentTier;
      currentTier = newTier;

      if (currentTier > 0 && !bonusUnlocked) {
        unlockBonusCollection();
      } else if (currentTier === 0 && bonusUnlocked) {
        lockBonusCollection();
      } else if (currentTier > 0) {
        const maxBonus = getMaxBonusForTier(currentTier);
        const currentBonus = getTotalSelections(bonusSelections);

        // Clear excess bonus selections if tier decreased
        if (currentBonus > maxBonus) {
          let removed = 0;
          const toRemove = currentBonus - maxBonus;
          for (const [variantId, item] of bonusSelections) {
            if (removed >= toRemove) break;
            const removeQty = Math.min(item.quantity, toRemove - removed);
            if (removeQty >= item.quantity) {
              bonusSelections.delete(variantId);
              secondaryCollection
                .querySelectorAll(`.product-card[data-variant-id="${variantId}"] .quantity-count`)
                .forEach(el => {
                  el.textContent = '0';
                });
            } else {
              item.quantity -= removeQty;
              secondaryCollection
                .querySelectorAll(`.product-card[data-variant-id="${variantId}"] .quantity-count`)
                .forEach(el => {
                  el.textContent = item.quantity;
                });
            }
            removed += removeQty;
          }
        }

        updateBonusDisplay();

        if (newTier > oldTier) {
          if (notis) notis.create('Tier Upgraded! 🎉', `You can now select ${maxBonus} bonus items!`, 3, true);
        }
      }
    }
  }
  
  // Unlock bonus collection
  function unlockBonusCollection() {
    bonusUnlocked = true;
    bonusLockedSection.style.display = 'none';
    bonusUnlockedSection.style.display = 'block';
    bonusUnlockedSection.classList.add('just-unlocked');

    // Enable bonus product buttons
    secondaryCollection.querySelectorAll('.quantity-selector button').forEach(btn => {
      btn.disabled = false;
    });

    // Scroll to bonus section
    setTimeout(() => {
      document.getElementById('bonustops').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);

    const maxBonus = getMaxBonusForTier(currentTier);
    if (notis) notis.create('Bonus Unlocked! 🎉', `Choose ${maxBonus} bonus item${maxBonus > 1 ? 's' : ''}.`, 4, true);

    setTimeout(() => {
      bonusUnlockedSection.classList.remove('just-unlocked');
    }, 500);

    updateBonusDisplay();
  }
  
  // Lock bonus collection
  function lockBonusCollection() {
    bonusUnlocked = false;
    currentTier = 0;
    bonusLockedSection.style.display = 'block';
    bonusUnlockedSection.style.display = 'none';

    secondaryCollection.querySelectorAll('.product-card').forEach(card => {
      card.querySelector('.quantity-count').textContent = '0';
      card.querySelectorAll('.quantity-selector button').forEach(btn => {
        btn.disabled = true;
      });
    });

    bonusSelections.clear();
    updateBonusDisplay();
    updateButtons();
  }
  
  // Update button states
  function updateButtons() {
    const primaryTotal = getTotalSelections(primarySelections);
    const bonusTotal = getTotalSelections(bonusSelections);
    const tier = currentTier;
    const maxBonus = getMaxBonusForTier(tier);

    const isValidPrimaryCount = primaryTotal === 3 || primaryTotal === 6 || primaryTotal === 9;

    addToCartButtons.forEach(button => {
      if (!button) return;

      const btnText = button.querySelector('#btntext') || button.querySelector('#btnBTMtext');

      if (primaryTotal === 0) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = 'SELECT 3, 6, OR 9 PRODUCTS';
      } else if (!isValidPrimaryCount) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = 'SELECT EXACTLY 3, 6, OR 9 PRODUCTS';
      } else if (tier === 0) {
        button.disabled = true;
        button.style.animation = 'none';
        const needed = 3 - primaryTotal;
        if (btnText) btnText.textContent = `SELECT ${needed} MORE TO UNLOCK BONUS`;
      } else if (bonusTotal === 0) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = `NOW CHOOSE ${maxBonus} BONUS ITEM${maxBonus > 1 ? 'S' : ''}`;
      } else if (bonusTotal < maxBonus) {
        button.disabled = true;
        button.style.animation = 'none';
        if (btnText) btnText.textContent = `SELECT ${maxBonus - bonusTotal} MORE BONUS ITEM${(maxBonus - bonusTotal) > 1 ? 'S' : ''}`;
      } else if (bonusTotal === maxBonus && isValidPrimaryCount) {
        button.disabled = false;
        if (btnText) btnText.textContent = 'ADD ALL TO CART';
        button.style.animation = 'pulse 1s infinite';
      }
    });
  }
  
  // Handle add to cart
  async function handleAddToCart(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const spinner = button.querySelector('.loading-overlay__spinner');
    const btnText = button.querySelector('#btntext') || button.querySelector('#btnBTMtext');

    if (spinner) spinner.classList.remove('hidden');
    if (btnText) btnText.textContent = 'ADDING TO CART...';
    button.disabled = true;

    try {
      const items = [];

      // Determine tier-specific bundle *type keys* (must match your BF25_BUNDLES config)
      let bundleKey = '';
      let freeBundleKey = '';

      if (currentTier === 1) {
        bundleKey = 'BF25_3';
        freeBundleKey = 'BF25_3Free';
      } else if (currentTier === 2) {
        bundleKey = 'BF25_6';
        freeBundleKey = 'BF25_6Free';
      } else if (currentTier === 3) {
        bundleKey = 'BF25_9';
        freeBundleKey = 'BF25_9Free';
      } else {
        // Safety: shouldn't happen if buttons are disabled correctly
        throw new Error('Invalid bundle tier');
      }

      // 👇 New: unique bundle instance ID for this "ADD ALL TO CART" click
      const bundleInstanceId = createBundleInstanceId();

      // Add primary selections (paid items)
      primarySelections.forEach((item, variantId) => {
        items.push({
          id: variantId,
          quantity: item.quantity,
          properties: {
            _bundleId: bundleInstanceId, // instance
            _bundleKey: bundleKey       // type key, e.g. "BF25_3"
          }
        });
      });

      // Add bonus selections (free items)
      bonusSelections.forEach((item, variantId) => {
        items.push({
          id: variantId,
          quantity: item.quantity,
          properties: {
            _bundleId: bundleInstanceId, // same instance
            _bundleKey: freeBundleKey    // e.g. "BF25_3Free"
          }
        });
      });
      
      // Add all items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      
      if (response.ok) {
        if (notis) notis.create('Success! ✅', 'Successfully added to cart!', 2, true);
        setTimeout(() => {
          window.location.href = '/cart';
        }, 1000);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || errorData.message || 'Failed to add items to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      if (notis) notis.create('Error ❌', error.message || 'Error adding to cart. Please try again.', 5, true);
    } finally {
      if (spinner) spinner.classList.add('hidden');
      if (btnText) btnText.textContent = 'ADD ALL TO CART';
      button.disabled = false;
    }
  }
  
  // Initialize everything
  init();
});
